import WithQuery from '@/utils/WithQuery';
import useResourceDetailsPage from './availability-details.controller';
import ResourceDetailsSuccessPage from './components/availability-details-success/availability-details-success.page';

export default WithQuery({
	Component: ResourceDetailsSuccessPage,
	useHook: useResourceDetailsPage,
});
